import { secondsToFullString, secondsToString } from '@mote/helpers'
import { Text, VisuallyHidden } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'

export const RecordingTime = props => {
  const {
    fontSize = 14,
    lineHeight = '140%',
    fontWeight = 400,
    dotSize = 8,
    minWidth = 0,
    gap = 4,
    seconds = 0,
    showDot = true,
    ...rest
  } = props
  return (
    <IndicatorsContainer
      tag='span'
      aria-label='Remaining time'
      fontSize={fontSize}
      lineHeight={lineHeight}
      fontWeight={fontWeight}
      minWidth={minWidth}
      gap={gap}
      {...rest}
    >
      {showDot && (
        <PulsingDot
          className='recording-indicator'
          size={dotSize}
          tabIndex={-1}
        />
      )}
      <VisuallyHidden>{secondsToFullString(seconds)}</VisuallyHidden>
      <span aria-hidden={true}>{secondsToString(seconds)}</span>
    </IndicatorsContainer>
  )
}

const IndicatorsContainer = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  gap: ${({ gap }) => gap}px;
  min-width: ${({ minWidth }) => minWidth}px;
`

const PulsingDot = styled.span`
  display: block;
  flex-shrink: 0;
  border-radius: 100%;
  background: ${th.color('primary.base')};

  ${({ size }) => css`
    width: ${size}px;
    height: ${size}px;
  `};

  animation: pulsing 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulsing {
    50% {
      opacity: 0.5;
    }
  }
`
